import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href"]

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelIcon',
  props: {
  channelType: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const logo = computed(() => {
  switch (props.channelType) {
    case 'sms-bt':
      return 'bt';
    case 'sms-govuknotify':
      return 'govuk-crown';
    case 'messenger':
      return 'fb-messenger';
    case 'twitter-dm':
      return 'twitter';
    case 'instagram':
      return 'instagram';
    case 'whatsapp':
      return 'whatsapp';
    case 'google-bm':
      return 'google-bm';
    default:
      return 'web-assistant';
  }
});

const isWebAssistant = computed(() => props.channelType === 'web-assistant');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["app-icon", { 'web-assistant': isWebAssistant.value }])
  }, [
    _createElementVNode("use", {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": `#${logo.value}`
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})